import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Button, Divider, Flex, FocusLock, Heading, Slide, Text, useOutsideClick } from '@chakra-ui/react';
import { analytics, formatDataTestId, useScreenSize } from '@whitbread-eos/utils';
import { useTranslation } from 'next-i18next';
import { useEffect, useRef, useState } from 'react';
import { FilterPanelClearButton, FilterPanelCloseButton } from '../../utils/FilterPanelControls';
import { createCheckboxList } from '../../utils/createCheckboxList';
import { onPanelEscapeKeyDown } from '../../utils/filterPanelKeyboard';
import { useFilterPanelTypography } from '../../utils/useFilterPanelTypography';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DLP_FILTERS_HEADING_ID = 'DLP-Filters-heading';
var CLEAR_FILTERS_ENABLER = 2;
export default function DestinationFilters(_ref) {
  var _label$reset;
  var selectedFilters = _ref.selectedFilters,
    setSelectedFilters = _ref.setSelectedFilters,
    _ref$isDisabled = _ref.isDisabled,
    isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
    labels = _ref.labels,
    _ref$showClearFilters = _ref.showClearFilters,
    showClearFilters = _ref$showClearFilters === void 0 ? true : _ref$showClearFilters,
    leftIcon = _ref.leftIcon,
    buttonProps = _ref.buttonProps;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFilterOpen = _useState2[0],
    setIsFilterOpen = _useState2[1];
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFilterPanelTypogr = useFilterPanelTypography(buttonProps),
    headingTypography = _useFilterPanelTypogr.headingTypography,
    labelTypography = _useFilterPanelTypogr.labelTypography,
    mergedButtonProps = _useFilterPanelTypogr.mergedButtonProps;
  var ref = useRef(null);
  var filterButtonRef = useRef(null);
  useOutsideClick({
    ref: ref,
    handler: () => setIsFilterOpen(false)
  });
  var filters = labels.filters,
    dynamicFilters = labels.dynamicFilters;
  var label = filters.label,
    info = filters.info;
  var baseDataTestId = 'DLP-Filters';
  var _useScreenSize = useScreenSize(),
    isLessThanSm = _useScreenSize.isLessThanSm;
  useEffect(() => {
    document.body.style.overflow = isFilterOpen ? 'hidden' : 'auto';
  }, [isFilterOpen]);
  var handleFilterChange = (e, operator) => {
    var _e$target$value, _e$target$parentEleme, _e$target$parentEleme2, _window$analyticsData, _window$analyticsData2;
    var newState = e.target.checked ? [...selectedFilters, {
      codes: (_e$target$value = e.target.value) === null || _e$target$value === void 0 ? void 0 : _e$target$value.split(',').flat(),
      name: e.target.ariaLabel,
      operator: operator,
      queryParam: (_e$target$parentEleme = (_e$target$parentEleme2 = e.target.parentElement) === null || _e$target$parentEleme2 === void 0 ? void 0 : _e$target$parentEleme2.getAttribute('data-query-param')) !== null && _e$target$parentEleme !== void 0 ? _e$target$parentEleme : ''
    }] : selectedFilters.filter(selectedFilter => {
      var selectedFilterCodes = selectedFilter.codes;
      if (selectedFilterCodes.length > 1) {
        return selectedFilterCodes.join(',') !== e.target.value;
      }
      return selectedFilterCodes[0] !== e.target.value;
    });
    setSelectedFilters(newState);
    analytics.update({
      dlp: _objectSpread(_objectSpread({}, (_window$analyticsData = (_window$analyticsData2 = window.analyticsData) === null || _window$analyticsData2 === void 0 ? void 0 : _window$analyticsData2.dlp) !== null && _window$analyticsData !== void 0 ? _window$analyticsData : {}), {}, {
        searchFilter: newState.map(filter => filter.codes).join(','),
        filterSectionOpened: true,
        filtersCleared: false
      })
    });
  };
  var handleClearFilters = () => {
    var _window$analyticsData3, _window$analyticsData4;
    setSelectedFilters([]);
    analytics.update({
      dlp: _objectSpread(_objectSpread({}, (_window$analyticsData3 = (_window$analyticsData4 = window.analyticsData) === null || _window$analyticsData4 === void 0 ? void 0 : _window$analyticsData4.dlp) !== null && _window$analyticsData3 !== void 0 ? _window$analyticsData3 : {}), {}, {
        filtersCleared: true,
        searchFilter: ''
      })
    });
  };
  return _jsxs(Box, {
    children: [_jsx(Slide, {
      direction: 'left',
      in: isFilterOpen,
      unmountOnExit: true,
      style: {
        zIndex: 999,
        background: 'rgba(0,0,0,0.5)'
      },
      children: _jsx(FocusLock, {
        restoreFocus: true,
        finalFocusRef: filterButtonRef,
        initialFocusRef: ref,
        children: _jsxs(Box, _objectSpread(_objectSpread({}, panelStyles), {}, {
          "data-testid": formatDataTestId(baseDataTestId, 'Wrapper'),
          id: formatDataTestId(baseDataTestId, 'Wrapper'),
          ref: ref,
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": DLP_FILTERS_HEADING_ID,
          tabIndex: -1,
          onKeyDown: onPanelEscapeKeyDown(() => setIsFilterOpen(false)),
          children: [_jsxs(Box, {
            pt: "2.5rem",
            position: "sticky",
            children: [_jsxs(Flex, {
              justifyContent: "space-between",
              alignItems: "center",
              children: [_jsx(Heading, _objectSpread(_objectSpread({
                as: "h2",
                size: "none",
                id: DLP_FILTERS_HEADING_ID
              }, headingTypography), {}, {
                color: "var(--chakra-colors-darkGrey1)",
                children: label === null || label === void 0 ? void 0 : label.header
              })), _jsx(FilterPanelCloseButton, {
                testId: formatDataTestId(baseDataTestId, 'Close-Button'),
                label: t('searchResults.filters.close', {
                  defaultValue: 'Close'
                }),
                onClose: () => setIsFilterOpen(false)
              })]
            }), selectedFilters.length >= CLEAR_FILTERS_ENABLER && _jsx(FilterPanelClearButton, _objectSpread(_objectSpread({}, clearFiltersStyles), {}, {
              testId: formatDataTestId(baseDataTestId, 'Clear-Filters-Button'),
              label: (_label$reset = label === null || label === void 0 ? void 0 : label.reset) !== null && _label$reset !== void 0 ? _label$reset : t('tableFilter.clearAll', {
                defaultValue: 'Clear all filters'
              }),
              onClear: handleClearFilters
            })), _jsx(Divider, _objectSpread({}, dividerStyles))]
          }), _jsx(Box, {
            overflow: "auto",
            height: "82vh",
            children: dynamicFilters === null || dynamicFilters === void 0 ? void 0 : dynamicFilters.map((dynamicFilterSection, i) => {
              var _dynamicFilterSection2, _info$lift;
              var groupHeadingId = "DLP-Filters-group-".concat(i, "-heading");
              return _jsxs(Box, {
                pt: "md",
                role: "group",
                "aria-labelledby": groupHeadingId,
                children: [_jsx(Heading, _objectSpread(_objectSpread({
                  as: "h3",
                  id: groupHeadingId,
                  mb: "sm",
                  size: "none"
                }, headingTypography), {}, {
                  color: "var(--chakra-colors-darkGrey1)",
                  children: dynamicFilterSection.groupTitle
                })), createCheckboxList(baseDataTestId, selectedFilters, e => {
                  var _dynamicFilterSection;
                  return handleFilterChange(e, (_dynamicFilterSection = dynamicFilterSection.groupOperator) !== null && _dynamicFilterSection !== void 0 ? _dynamicFilterSection : '');
                }, (_dynamicFilterSection2 = dynamicFilterSection === null || dynamicFilterSection === void 0 ? void 0 : dynamicFilterSection.groupItems) !== null && _dynamicFilterSection2 !== void 0 ? _dynamicFilterSection2 : [], (_info$lift = info === null || info === void 0 ? void 0 : info.lift) !== null && _info$lift !== void 0 ? _info$lift : '', true, labelTypography), dynamicFilters.length - 1 !== i && _jsx(Divider, _objectSpread({}, dividerStyles))]
              }, dynamicFilterSection.groupTitle);
            })
          })]
        }))
      })
    }), _jsxs(Flex, {
      alignItems: "center",
      children: [_jsx(Button, _objectSpread(_objectSpread(_objectSpread({
        ref: filterButtonRef,
        "data-testid": formatDataTestId(baseDataTestId, 'Open-Button'),
        size: "sm",
        variant: "genericSecondary",
        isDisabled: isDisabled,
        onClick: () => setIsFilterOpen(true),
        "aria-haspopup": "dialog",
        "aria-expanded": isFilterOpen,
        "aria-controls": isFilterOpen ? formatDataTestId(baseDataTestId, 'Wrapper') : undefined,
        leftIcon: leftIcon
      }, filterButtonWidth), mergedButtonProps), {}, {
        overflow: "hidden",
        children: t('dlp.filters.filtersAmount').replace('({amount})', !isLessThanSm && (selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.length) > 0 ? "(".concat(selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.length, ")") : '')
      })), showClearFilters && selectedFilters.length > 0 && _jsx(Text, _objectSpread(_objectSpread({}, clearFiltersStyles), {}, {
        display: {
          mobile: 'none',
          sm: 'block'
        },
        mt: "0",
        mb: "0",
        ml: "0.938rem",
        onClick: handleClearFilters,
        "data-testid": formatDataTestId(baseDataTestId, 'Clear-All-Button'),
        children: t('tableFilter.clearAll')
      }))]
    })]
  });
}
var filterButtonWidth = {
  w: {
    mobile: '8.75rem',
    xs: '10.25rem',
    sm: '7.75rem',
    lg: '11.5rem'
  }
};
var panelStyles = {
  background: 'baseWhite',
  height: '100vh',
  width: 'full',
  px: 'lg',
  maxWidth: {
    base: '19.063rem',
    xs: '19.438rem',
    sm: '21.875rem',
    md: '23.375rem',
    lg: '26.063rem',
    xl: '30.375rem'
  },
  zIndex: '9999'
};
var dividerStyles = {
  borderColor: 'lightGrey2',
  mt: 'lg'
};
var clearFiltersStyles = {
  fontSize: 'md',
  fontWeight: 'normal',
  lineHeight: '3',
  textDecoration: 'underline',
  color: 'btnSecondaryEnabled',
  marginTop: 'md',
  marginBottom: 'lg',
  _hover: {
    cursor: 'pointer'
  }
};